import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { formateDateToJalali, getAgeJalali } from "../../utils/Functions";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 50,
  },
  pageTitle: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  title: {
    fontFamily: "rokh",
    textAlign: "right",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 900,
  },
  subtitle: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },
  section: {
    backgroundColor: "#fff",
    border: "1px solid #eee",
    borderRadius: 10,
    marginBottom: 10,
  },
  content: {
    padding: 15,
  },
  subTitle: {
    width: "100%",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5,
    textAlign: "right",
  },
  text: {
    width: "100%",
    fontSize: 12,
    marginBottom: 5,
    textAlign: "right",
  },
  listItem: {
    width: "100%",
    textAlign: "right",
    fontSize: 12,
  },
  ageContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
    gap: 5,
    width: "50%",
  },
  ageBox: {
    flex: 1,
    padding: 10,
    borderRadius: 10,
    textAlign: "center",
    backgroundColor: "#FFA500",
  },
  ageTitle: {
    fontSize: 14,
  },
  ageNumber: {
    fontSize: 16,
    fontWeight: "bold",
  },
  notProText: {
    width: "100%",
    textAlign: "right",
    fontSize: 12,
    marginTop: 12,
    fontFamily: "rokh",
    fontWeight: 900,
  },
});

const PdfBiologicalAge = ({ testInfo, testResults, is_pro }: any) => (
  <View style={styles.container}>
    <View style={styles.pageTitle}>
      <Text style={styles.title}>سن بایولوژیک شما</Text>
      <Text style={styles.subtitle}>
        این موارد رو در رابطه با وضعیت فیزیکی بدنت می‌شه گفت{" "}
      </Text>
    </View>

    <View style={styles.section}>
      <View style={styles.content}>
        <Text style={styles.text}>
          برخی از دانشمندان معتقدند که با استفاده از رژیم‌های غذایی خاص و مداخله
          در سبک زندگی می‌توان فرایند افزایش سن بیولوژیکی را به تأخیر انداخت.
          روش‌های پیشنهادی این گروه از دانشمندان عبارت‌اند از:
        </Text>
        <Text style={styles.listItem}>
          مصرف مواد غذایی سالم مانند سبزیجات رنگارنگ و پروتئین حیوانی •
        </Text>
        <Text style={styles.listItem}> مصرف آب کافی در طول روز •</Text>
        <Text style={styles.listItem}>
          حداقل ۳۰ دقیقه ورزش و تحرک بدنی در هر ۵ روز •
        </Text>
        <Text style={styles.listItem}>مدیتیشن منظم و تمرینات آرامش‌بخش •</Text>
        <Text style={styles.listItem}> حداقل ۷ ساعت خواب شبانه • </Text>

        {!is_pro && (
          <Text style={styles.notProText}>
            برای محاسبه سن بایولوژیکت، از تحلیل پیشرفته استفاده کن
          </Text>
        )}

        <View style={styles.ageContainer}>
          <View style={styles.ageBox}>
            <Text style={styles.ageNumber}>
              {is_pro ? Math.round(testResults?.biological_age) : "-"}
            </Text>
            <Text style={styles.ageTitle}>سن بایولوژیکی</Text>
          </View>
          <View style={styles.ageBox}>
            <Text style={styles.ageNumber}>
              {getAgeJalali(testInfo?.birth_day)}
            </Text>
            <Text style={styles.ageTitle}>سن حقیقی</Text>
          </View>
        </View>
      </View>
    </View>
  </View>
);

export default PdfBiologicalAge;
